import { dashboardPath } from 'components/Routes'

import { Grid2, Typography } from '@mui/material'
import Button from 'components/Button'
import DefaultLayout from 'components/layout/DefaultLayout'
import { useNavigate } from 'react-router-dom'

export default function VerificationSuccess(): JSX.Element {
  const navigate = useNavigate()

  return (
    <DefaultLayout backgroundColor='white' heading='Good as gold!'>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12 }}>
          <Typography variant='body1'>Nice one - you're in!</Typography>
        </Grid2>
        <Grid2 size={{ xs: 12 }}>
          <Typography variant='body1'>
            You are now verified, and able to start trading.
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12 }}>
          <Button
            color='primary'
            fullWidth
            onClick={() => navigate(dashboardPath())}
          >
            Let's trade
          </Button>
        </Grid2>
      </Grid2>
    </DefaultLayout>
  )
}
